export default "__VITE_ASSET__CknNKXbW__"